export interface KioskSplashMediaRef {
  readonly url?: string;
  readonly mime_type?: string;
}

/** True when the media should play in a `<video>` element (not a GIF or still image). */
export function isPlayableVideoMedia(media: KioskSplashMediaRef | null | undefined): boolean {
  if (!media?.url?.trim()) {
    return false;
  }

  const mime = media.mime_type?.toLowerCase() ?? '';
  if (mime.startsWith('video/')) {
    return true;
  }
  if (mime.startsWith('image/')) {
    return false;
  }

  return /\.(mp4|webm|ogv|ogg|mov|mkv)(\?|#|$)/i.test(media.url);
}

/**
 * Background still for kiosk splash: `background_image`, or a non-video `background_video`
 * (e.g. GIF bound via an image-type journey param on the video prop).
 */
export function resolveKioskSplashBackgroundImageUrl(
  backgroundVideo: KioskSplashMediaRef | null | undefined,
  backgroundImage: KioskSplashMediaRef | null | undefined,
): string | undefined {
  if (backgroundVideo?.url && !isPlayableVideoMedia(backgroundVideo)) {
    return backgroundVideo.url;
  }
  return backgroundImage?.url;
}
